import * as React from "react";
import { SiteModel } from "src/model/model";
import { observer } from "mobx-react-lite";
import { SchemaType, fetchArticles } from "src/modules/sanityApi";
import { SanityImage } from "sanity-image";
import { SocialMediaIcon } from "src/components/spriteWrappers";
import { SocialMediaLink } from "src/components/socialMediaLink";
import {useEffect} from "react";
import "src/styles/music.css";

export const Music = observer(({session}: {session: SiteModel}) => {
	React.useEffect(() => {
		const fetchSongs = async () => {
			if (!session.songsHaveLoaded) {
				try {
					console.log("No songs loaded, fetching songs...");
					const fetchedPosts = await fetchArticles(SchemaType.Music);
					session.addSongs(fetchedPosts);
				} catch (error) {
					console.error("Error fetching songs:", error);
				}
			}
		};

		fetchSongs();
	}, [session]);

	return (
		<MusicView
		songs={session.allSongs}
		/>
	);
});

function MusicView(props){
	
	// make sure the user views the page from the top
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [])

	return (
		<main className="standard-width">
        <h1>Music</h1>
        <div className="music-container">
			{props.songs.map(song => {

				return (
					<React.Fragment key={song.slug}>
						<SongContainer 
						title={song.title} 
						mediaLinks={song.mediaLinks} 
						releaseDate={song.releaseDate}
						image={song.image}
						centerIdol={song.idol}
						/>
					</React.Fragment>
				)

			})}
        </div>
    </main>
	)
}

function SongContainer(props){
	return ( 
	<div 
	className="song-container scale-on-hover" 
	style={{
		"--logo-color": `var(--${props.centerIdol}_strong)`,
		"--clr-strong": `var(--${props.centerIdol}_strong)`,
		"--clr-main": `var(--${props.centerIdol}_main)`,
		"--clr-soft": `var(--${props.centerIdol}_soft)`,
		"--clr-light": `var(--${props.centerIdol}_light)`,
		"--clr-font": `var(--${props.centerIdol}_font)`,
		}}>
		<SanityImage 
		id={props.image.asset._ref} 
		projectId="47i27g55" 
		dataset="production"
		width={250}
		height={250}
		mode="cover"
		/>
		<p className="song-title">{props.title}</p>
		<div className="socials-container">
			{props.mediaLinks.map(mediaLink => {
				return (
					<React.Fragment key={mediaLink.platform}>
						<SocialMediaLink
						to={mediaLink.url}
						platform={mediaLink.platform}
						/>
					</React.Fragment>
				)
			})}
		</div>

	</div>

	)
}